import React from "react";
import styled, { css } from "styled-components";

const StyledTrack = styled.div`
	width: 100%;
	height: 18px;
	background-color: var(--dz-ref-color-gray100);
	border-radius: ${({ theme: { borderRadius } }) => borderRadius.progressBar};
	z-index: 2;
	overflow: hidden;

	${({ height }) =>
		height &&
		css`
			height: ${height};
		`}
`;

const MainTrack = styled(StyledTrack)`
	background-color: ${({ theme: { colors } }) => colors.primary};
	height: 100%;
	background: linear-gradient(124deg, #315398, #5085eb);
	background-size: 200% 200%;
	transform: translateX(${({ percent }) => -100 + Number(percent)}%);
	transition: transform 0.5s;
	position: relative;
	overflow: hidden;
`;

const UploadProgressBar = ({ percent, height }) => {
	return (
		<StyledTrack height={height}>
			<MainTrack percent={percent} />
		</StyledTrack>
	);
};

export default UploadProgressBar;
